import { supabase } from "../supabase/client";

export const handleOAuthCallback = async () => {
  try {
    // Get session from URL parameters
    const {
      data: { session },
      error: sessionError,
    } = await supabase.auth.getSession();

    if (sessionError) throw sessionError;
    if (!session) throw new Error("No session found");

    // Wait briefly for the trigger to create the profile
    await new Promise((resolve) => setTimeout(resolve, 1000));

    // Get user profile with retries
    let profile = null;
    let retries = 3;
    let error = null;

    while (retries > 0 && !profile) {
      try {
        const { data, error: profileError } = await supabase
          .from("users")
          .select(
            `
            *,
            creator_profile:creator_profiles(*)
          `,
          )
          .eq("id", session.user.id)
          .single();

        if (profileError) throw profileError;
        if (data) {
          profile = data;
          break;
        }
      } catch (e) {
        error = e;
        retries--;
        if (retries > 0) {
          // Wait with exponential backoff
          await new Promise((resolve) =>
            setTimeout(resolve, Math.pow(2, 3 - retries) * 1000),
          );
        }
      }
    }

    if (!profile) {
      throw error || new Error("Failed to get user profile");
    }

    return profile;
  } catch (error) {
    console.error("OAuth callback error:", error);
    throw error;
  }
};
